'use client';

import { type FC, useMemo } from 'react';

import { MenuFloatingContext } from './context/menu-floating.context';
import { MenuRootContext } from './context/menu-root.context';
import { useMenu } from './hooks/use-menu';
import type { MenuRootPropsInterface } from './types/menu-root.types';

/**
 * @since 10.0.0
 */
export const MenuRoot: FC<MenuRootPropsInterface> = (props: MenuRootPropsInterface) => {
  const { children, dividers = false, ...rest } = props;
  const { menu, floating } = useMenu(rest);
  const contextValue = useMemo(() => ({ dividers, menu }), [dividers, menu]);
  return (
    <MenuRootContext.Provider value={contextValue}>
      <MenuFloatingContext.Provider value={floating}>{children}</MenuFloatingContext.Provider>
    </MenuRootContext.Provider>
  );
};

MenuRoot.displayName = 'Menu.Root';
